import React, { Component } from 'react';
import { Select } from '../common/Form';
import { set } from "lodash";
import { v4 as uuidv4 } from 'uuid';

class AllergenForm extends Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        
        this.renderRow = this.renderRow.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.onMoveUp = this.onMoveUp.bind(this);
        this.onMoveDown = this.onMoveDown.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    onChange(name, value) {
        this.props.onChange(set([ ...this.props.value ], name, value));
    }

    onAdd(index) {
        const entries = [ ...this.props.value ];
        entries.push({ id: uuidv4(), allergen_id: "" });
        this.props.onChange(entries);
    }

    onMoveUp(index) {
        if (index <= 0) {
            return;
        }

        const entries = [ ...this.props.value ];

        const value = entries[index - 1];
        entries[index - 1] = entries[index]
        entries[index] = value

        this.props.onChange(entries);
    }
    
    onMoveDown(index) {
        const entries = [ ...this.props.value ];

        if (index >= entries.length - 1) {
            return;
        }

        const value = entries[index + 1];
        entries[index + 1] = entries[index]
        entries[index] = value

        this.props.onChange(entries);
    }

    onDelete(index) {
        const entries = this.props.value.filter((v, i) => i !== index);
        this.props.onChange(entries);
    }

    renderRow(row, index) {
        const options = this.props.allergens && this.props.allergens.map((allergen) => {
            return {
                value: allergen.id,
                label: allergen.name
            };
        });

        // list of allergen ids selected
        const used = this.props.value.map((value) => value.allergen_id);

        // remove selected allergens to prevent choosing the same twice
        const filteredOptions = options.filter((option) => option.value === row.allergen_id || !used.includes(option.value));

        return (
            <div key={row.id} className="field is-horizontal">
                <div className="field-body">
                    <Select
                        placeholder="Escolha um alergénio..."
                        required={true}
                        value={row.allergen_id}
                        options={filteredOptions}
                        onChange={(value) => this.onChange(`[${index}].allergen_id`, value) }
                        style={{ maxWidth: '400px' }}
                    />
                    <div className="buttons" style={{ flexWrap: 'nowrap', alignItems: 'flex-end' }}>
                        <button type="button" className="button is-light" disabled={index <= 0} onClick={(event) => this.onMoveUp(index)}>
                            <span className="icon is-small">
                                <i className="fas fa-arrow-up"></i>
                            </span>
                        </button>
                        <button type="button" className="button is-light" disabled={this.props.value && index >= this.props.value.length - 1} onClick={(event) => this.onMoveDown(index)}>
                            <span className="icon is-small">
                                <i className="fas fa-arrow-down"></i>
                            </span>
                        </button>
                        <button type="button" className="button is-light is-danger" onClick={(event) => this.onDelete(index)}>
                            <span className="icon is-small">
                                <i className="far fa-trash-alt"></i>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        var allergens = this.props.value;
        var rows = []

        if (allergens) {
            // set state ids for React (will not be persisted)
            allergens = allergens.map(allergen => {
                return { id: uuidv4(), ...allergen };
            });

            rows = allergens.map((allergen, i) => this.renderRow(allergen, i));
        }

        const isTrial = this.props.user.plan === 'TRIAL' || this.props.user.plan === 'EXPIRED';

        return (
            <>
                { rows }
                <button type="button" className="button is-light is-success" disabled={isTrial && rows.length >= 2} onClick={() => this.onAdd()}>
                    <span className="icon is-small">
                        <i className="fas fa-plus"></i>
                    </span>
                    <span>Adicionar Alergénio</span>
                </button>
            </>
        );
    }
}

export default AllergenForm;
